import React, { useEffect, useState } from 'react'
import { useTexture } from '@react-three/drei';

function Plate({color}) {
  const goldTexture = useTexture('/images/golden-texture.jpg');
  const silverTexture = useTexture('/images/silver-texture.jpg');
  const diamondTexture = useTexture('/images/diamond-texture.jpg');
  const rubyTexture = useTexture('/images/ruby-texture.jpg');
  const [currentTexture, setCurrentTexture] = useState(silverTexture)

  useEffect(() => {
    if (color === '#C0C0C0') {
      setCurrentTexture(silverTexture)
    } else if (color === "#ffad35") {
      setCurrentTexture(goldTexture)
    } else if (color === "#36ffc9") {
      setCurrentTexture(diamondTexture)
    } else {
      setCurrentTexture(rubyTexture)
    }
  }, [color, silverTexture, goldTexture, diamondTexture, rubyTexture])
  

  return (
  <>
    <mesh receiveShadow position={[0,-1.12,0]}>
      <cylinderGeometry args={[2, 2, 0.25, 64]} />
      <meshStandardMaterial
      map={currentTexture}
        color={color}
        />
    </mesh>
    <mesh receiveShadow position={[0,-1.35,0]}>
      <cylinderGeometry args={[1.8, 1.8, 0.25, 64]} />
      <meshStandardMaterial
      map={currentTexture}
        color={color}
        />
    </mesh>
    <mesh receiveShadow position={[0,-1.58,0]}>
      <cylinderGeometry args={[2, 2, 0.25, 64]} />
      <meshStandardMaterial
      map={currentTexture}
        color={color}
        />
    </mesh>
  </>
  )
}

export default Plate